import useOneToOne from "@/utils/hooks/useOneToOne";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import { useEffect } from "react";
import { useBookOneToOneMutation } from "@/data/one-to-one.ts";
// import { useMe } from "@/data/user.ts";
import { Trans, useTranslation } from "react-i18next";
import LoadingButton from "@edusogno/primitives/loading-button";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import AbsoluteBackground from "@/components/ui/AbsoluteBackground.tsx";
import {
  options,
  topicsId,
  TopicsWithId,
} from "@/components/one-to-one/Constants.tsx";
import dayjs from "dayjs";

const SecondSessionDetails = () => {
  const { date, hour, category, topic } = useOneToOne();
  // const newDate = dayjs(date);

  const navigate = useNavigate();

  const { t } = useTranslation();
  // const { me } = useMe();

  useEffect(() => {
    if (!date && !hour) {
      navigate(routes.one_to_one);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, hour]);

  const {
    // mutate,
    isLoading,
  } = useBookOneToOneMutation();

  // const handleConfirm = () => {
  //   if (!me) return;

  //   mutate({
  //     token_tutor: tutor,
  //     user_token: me.item.user.token,
  //     data: dayjs(date).format("YYYY-MM-DD"),
  //     ora: hour,
  //     ora_fine: dayjs(dayjs(date).format("YYYY-MM-DD") + " " + hour)
  //       .add(1, "hour")
  //       .format("HH:mm"),
  //     titolo_argomento: options[Number(category)]?.text,
  //     descrizione:
  //       topicsId[options[Number(category)]?.key as keyof TopicsWithId][
  //         Number(topic)
  //       ].title,
  //     id_material:
  //       topicsId[options[Number(category)]?.key as keyof TopicsWithId][
  //         Number(topic)
  //       ].id,
  //   });
  // };

  return (
    <>
      <DashboardContentLayout className="relative z-10  pb-0 px-0 flex flex-col h-full">
        <AbsoluteBackground className={"bg-white z-5"} />
        <div
          className={
            "relative z-20 flex flex-col h-full justify-between py-4 px-6"
          }
        >
          <div
            className={
              "h-[218px] w-full bg-[#EEEEEE] rounded-[7px] flex  justify-center  items-center flex-col"
            }
          >
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="23" cy="23" r="23" fill="#74DFAC" />
              <path
                d="M13.9062 28.1271L18.429 31.7895C18.7177 32.0232 19.0788 32.1274 19.437 32.0804C19.7952 32.0334 20.1227 31.8388 20.3511 31.5373L32.0923 16.0449"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
            <p className={"text-secondary font-semibold my-4"}>
              {t("one_to_one.event_created_successfully")}
            </p>
            <p className={"text-xs text-secondary text-center"}>
              <Trans
                i18nKey="one_to_one.info_event_created"
                values={{
                  date: dayjs(date).format("ddd DD MMMM"),
                  hour,
                  topic:
                    topicsId[
                      options[Number(category)]?.key as keyof TopicsWithId
                    ][Number(topic)].title,
                }}
                components={{
                  b: <b className="font-semibold" />,
                }}
              />
            </p>
          </div>
          <div className={"flex gap-2  w-full flex-row justify-center"}>
            <LoadingButton
              onClick={() => navigate(routes.agenda)}
              loading={isLoading}
              disabled={isLoading}
              color={"primary"}
              size={"sm"}
            >
              {t("btns.go_to_agenda")}
            </LoadingButton>
          </div>
        </div>
      </DashboardContentLayout>
    </>
  );
};

export default SecondSessionDetails;
